export const getPosts = (state) => state.data.posts;

export const getPostById = (state, postId) => getPosts(state)[postId];

export const getSchedulePostDialogOpenFor = (state) =>
  state.posts.schedulePostDialogOpenFor;
